import React from 'react';
import { Immutable } from 'nuclear-js';
import PropTypes from 'prop-types';
import CreateReactClass from 'create-react-class';

import Subjects from './subjects';
import Data from './data';
import Pages from './pages';
import Students from './students';
import Class from './class';
import Status from './status';
import CommonValues from 'resources/common-values';

export default CreateReactClass({
    displayName: 'batch-print-content',

    PropTypes: {
        batchOptionState: PropTypes.bool.isRequired,
        createPdfAction: PropTypes.func.isRequired,
        displayPages: PropTypes.instanceOf(Immutable.List).isRequired,
        isFamilyReport: PropTypes.bool.isRequired,
        isSingleStudentMode: PropTypes.bool.isRequired,
        linkingStudies: PropTypes.instanceOf(Immutable.List).isRequired,
        nextButtonAction: PropTypes.func.isRequired,
        onSelectStudents: PropTypes.func.isRequired,
        selectedGroupByOption: PropTypes.oneOf([
            CommonValues.INSTRUCTION_AREAS_GROUPBY_TOPIC,
            CommonValues.INSTRUCTION_AREAS_GROUPBY_STANDARD,
        ]).isRequired,
        selectedModule: PropTypes.instanceOf(Immutable.Map).isRequired,
        selectedPrintFormat: PropTypes.instanceOf(Immutable.Set).isRequired,
        selectedStudentBids: PropTypes.instanceOf(Immutable.Set).isRequired,
        selectedStudentForPrinting: PropTypes.oneOf(['previous', 'current', 'next']).isRequired,
        selectedStudents: PropTypes.instanceOf(Immutable.Set).isRequired,
        selectedStudentsFromList: PropTypes.instanceOf(Immutable.Set).isRequired,
        selectData: PropTypes.func.isRequired,
        selectGroupBy: PropTypes.func.isRequired,
        selectPages: PropTypes.func.isRequired,
        selectStudents: PropTypes.func.isRequired,
        selectSubjects: PropTypes.func.isRequired,
        selectFormat: PropTypes.func.isRequired,
        studentPreviousSelection: PropTypes.oneOf(['previous', 'current', 'next']).isRequired,
        students: PropTypes.instanceOf(Immutable.List).isRequired,
        studentsChanged: PropTypes.bool.isRequired,
        subjectActive: PropTypes.instanceOf(Immutable.Map).isRequired,
        subjectBid: PropTypes.instanceOf(Immutable.Map).isRequired,
        togglePrintAndShare: PropTypes.func.isRequired,
        togglePrintFormat: PropTypes.func.isRequired,
        toggleStudentSelection: PropTypes.func.isRequired,
    },

    render() {
        const pageChoices = this.props.isFamilyReport ? null : (
            <Pages
                batchOptionState={this.props.batchOptionState}
                displayPages={this.props.displayPages}
                isHelpBoxOpen={this.props.isHelpBoxOpen}
                nextButtonAction={this.props.nextButtonAction}
                selectedGroupByOption={this.props.selectedGroupByOption}
                selectedModule={this.props.selectedModule}
                selectGroupBy={this.props.selectGroupBy}
                selectPages={this.props.selectPages}
            />
        );

        const classSelection =
            this.props.dropDowns && this.props.isFamilyReportURL ? (
                <Class
                    dropDowns={this.props.dropDowns}
                    nextButtonAction={this.props.nextButtonAction}
                    classSelected={this.props.classSelected}
                />
            ) : null;

        const status = this.props.isFamilyReport ? <Status nextButtonAction={this.props.nextButtonAction} /> : null;

        return (
            <div id="print-batch-content">
                {classSelection}
                <Subjects
                    nextButtonAction={this.props.nextButtonAction}
                    batchOptionState={this.props.batchOptionState}
                    selectSubjects={this.props.selectSubjects}
                    subjectActive={this.props.subjectActive}
                    subjectBid={this.props.subjectBid}
                />
                <Data
                    batchOptionState={this.props.batchOptionState}
                    linkingStudies={this.props.linkingStudies}
                    nextButtonAction={this.props.nextButtonAction}
                    selectData={this.props.selectData}
                />
                {pageChoices}
                <Students
                    batchOptionState={this.props.batchOptionState}
                    createPdfAction={this.props.createPdfAction}
                    isFamilyReportURL={this.props.isFamilyReportURL}
                    isSingleStudentMode={this.props.isSingleStudentMode}
                    nextButtonAction={this.props.nextButtonAction}
                    onSelectStudents={this.props.onSelectStudents}
                    selectFormat={this.props.selectFormat}
                    selectStudents={this.props.selectStudents}
                    selectedPrintFormat={this.props.selectedPrintFormat}
                    selectedStudentForPrinting={this.props.selectedStudentForPrinting}
                    selectedStudentBids={this.props.selectedStudentBids}
                    selectedStudents={this.props.selectedStudents}
                    selectedStudentsFromList={this.props.selectedStudentsFromList}
                    setClearSelectedStudents={this.props.setClearSelectedStudents}
                    studentPreviousSelection={this.props.studentPreviousSelection}
                    students={this.props.students}
                    studentsChanged={this.props.studentsChanged}
                    togglePrintAndShare={this.props.togglePrintAndShare}
                    togglePrintFormat={this.props.togglePrintFormat}
                    toggleStudentSelection={this.props.toggleStudentSelection}
                />
                {status}
            </div>
        );
    },
});
